import { OrderedMap } from 'immutable';
import type { ID, ReduxAction } from '../../../types';
import { AppState } from '@reducers/rootReducer';
import { Sharee } from '@models/Sharee';
import { addShareePermission, shareesFromProps, ShareStatus } from '@models/ShareStatus';
import {
  createShareeRequested,
  createShareeSucceeded,
  deleteShareePermissionRequested,
  fetchAllShareesSucceeded,
  updatePublicSharingRequested,
} from './utils';

export const ViewGroupPermission = 'view_list';
export type GroupSubPermission = 'view_list_notes' | 'view_list_moments' | 'view_list_contactinfo';
export type GroupPermission = typeof ViewGroupPermission | GroupSubPermission;

export const labelForGroupPermission: Record<GroupSubPermission, string> = {
  view_list_notes: 'Notes',
  view_list_moments: 'Moments',
  view_list_contactinfo: 'Sources',
};

export const supportedGroupPermissions: GroupSubPermission[] = [
  'view_list_notes',
  'view_list_moments',
  'view_list_contactinfo',
];

export class GroupSharee extends Sharee<GroupPermission> {
  constructor(props) {
    super(props);
  }

  get idForMainPermission(): ID {
    return this.idForPermission(ViewGroupPermission);
  }
}

export class GroupShareStatus extends ShareStatus<GroupPermission> {
  constructor(props: any = {}) {
    super(props);
    this.sharees = shareesFromProps(GroupSharee, props);
  }

  addShareePermission = addShareePermission.bind(this, GroupSharee);
}

export type GroupShareStatusesState = OrderedMap<ID, GroupShareStatus>;
const initialGroupsShareStatusesState = OrderedMap<ID, GroupShareStatus>();

/* Selectors */
export const selectGroupShareStatus = (groupID: ID) => (state: AppState) =>
  state.data.shareStatuses.groups.get(groupID, new GroupShareStatus());

export function groupShareStatusesReducer(
  state: GroupShareStatusesState = initialGroupsShareStatusesState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_ALL_GROUP_SHAREES_SUCCEEDED':
      return fetchAllShareesSucceeded(state, payload, GroupShareStatus);

    case 'UPDATE_PUBLIC_GROUP_SHARING_REQUESTED':
      return updatePublicSharingRequested(state, payload);

    case 'CREATE_GROUP_SHAREE_REQUESTED':
      return createShareeRequested(state, payload);

    case 'CREATE_GROUP_SHAREE_SUCCEEDED':
      return createShareeSucceeded(state, payload, GroupSharee);

    case 'DELETE_VERIFIED_GROUP_SHAREE_PERMISSION_REQUESTED':
    case 'DELETE_WAITING_GROUP_SHAREE_PERMISSION_REQUESTED':
      return deleteShareePermissionRequested(state, payload);

    default:
      return state;
  }
}
